import { ChartData } from "@/@types";
import { formatCurrency } from "@/utils";
import moment from "moment";

export class GeneralInfo {
  revenue: {
    session_count: number;
    revenue: string;
  };
  location: Array<{
    id: string;
    title: string;
    session_count: number;
    revenue: number;
  }> = [];
  users_registered: number;
  connectors_used: number;
  revenue_chart: ChartData;
  location_chart: ChartData;

  constructor(data: GeneralInfoResponse) {
    this.revenue = {
      session_count: data.revenue.session_count,
      revenue: formatCurrency(Number(data.revenue.revenue)),
    };

    this.revenue_chart = {
      labels: Object.keys(data.revenue.daily).map((elem) =>
        moment(elem).format("DD/MM/YY")
      ),
      values: Object.values(data.revenue.daily).map((elem) => elem),
    };

    this.location_chart = {
      labels: data.location.map((elem) => elem.title),
      values: data.location.map((elem) => elem.session_count),
    };

    this.location = data.location;
    this.users_registered = data.users_registered;
    this.connectors_used = data.connectors_used;
  }

  static empty: GeneralInfo = {
    revenue: {
      session_count: 0,
      revenue: "",
    },
    location: [],
    users_registered: 0,
    connectors_used: 0,
    revenue_chart: { labels: [], values: [] },
    location_chart: { labels: [], values: [] },
  };
}

export type GeneralInfoResponse = {
  revenue: {
    daily: { [key: string]: number };
    session_count: number;
    revenue: number;
  };
  location: Array<{
    id: string;
    title: string;
    session_count: number;
    revenue: number;
  }>;
  users_registered: number;
  connectors_used: number;
};
